var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "news-detail container" }, [
    _c(
      "div",
      { staticClass: "news-detail__container" },
      [
        _c(
          "z-link",
          {
            staticClass: "news-detail__link",
            attrs: {
              size: "m",
              iconPosition: "left",
              icon: "arrow",
              href: _vm.nav["back-link"],
            },
          },
          [_vm._v(_vm._s(_vm.text.linkText))]
        ),
        _vm._v(" "),
        _c("date-block", { attrs: { date: _vm.newsDate, size: "s" } }),
      ],
      1
    ),
    _vm._v(" "),
    _c("section", [
      _vm.newsData.category || _vm.newsData.type.value
        ? _c(
            "div",
            { staticClass: "news-detail__tags" },
            [
              _vm.newsData.type.value === "Пресс-релиз" ||
              _vm.newsData.type.value === "Press Release"
                ? _c(
                    "tag",
                    {
                      staticClass: "news-detail__tags-item",
                      attrs: { theme: "peach" },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.newsData.type.value) +
                          "\n            "
                      ),
                    ]
                  )
                : _c(
                    "tag",
                    {
                      staticClass: "news-detail__tags-item",
                      attrs: { theme: "gray" },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.newsData.type.value) +
                          "\n            "
                      ),
                    ]
                  ),
              _vm._v(" "),
              _vm.newsData.category
                ? _c(
                    "div",
                    _vm._l(_vm.newsData.category, function (tag, index) {
                      return _c(
                        "tag",
                        {
                          key: index,
                          staticClass: "news-detail__tags-item",
                          attrs: { theme: "gray" },
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(tag.value) +
                              "\n                "
                          ),
                        ]
                      )
                    }),
                    1
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.newsData.detailText
        ? _c(
            "div",
            { staticClass: "news-detail__detail html-content" },
            [_c("vue-raw", { attrs: { raw: _vm.newsData.detailText } })],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.newsData.aboutCompany.value === "Y"
        ? _c(
            "div",
            {
              staticClass:
                "news-detail__text news-detail__text-bg news-detail__text-bg--white u-bottom-margin--xl",
            },
            [
              _c(
                "h2",
                {
                  staticClass:
                    "news-detail__text news-detail__text--accent u-bottom-margin--xs",
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.text.aboutCompanyTitle) +
                      "\n            "
                  ),
                ]
              ),
              _vm._v(" "),
              _c("p", [_vm._v(_vm._s(_vm.text.aboutCompany))]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "u-bottom-margin--xl" },
        [
          _c("h2", { staticClass: "news-detail__title u-bottom-margin--m" }, [
            _vm._v(_vm._s(_vm.text.contactsTitle)),
          ]),
          _vm._v(" "),
          _c("z-contact-card", {
            attrs: {
              photo: "/images/people/_.jpeg",
              title: _vm.text.contacts.title,
              subtitle: _vm.text.contacts.desc,
              phone: _vm.phone,
              email: _vm.email,
            },
          }),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "news-detail__footer" },
      [
        _c(
          "z-link",
          {
            staticClass: "news-detail__link",
            attrs: {
              size: "m",
              iconPosition: "left",
              icon: "arrow",
              href: _vm.nav["back-link"],
            },
          },
          [_vm._v(_vm._s(_vm.text.linkText))]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }